let dt_index = null;
let microsite_id = null;
let variable_id = null;

export function index(params){

    dt_index = $('#variables_table').DataTable({
        ajax: {
            url: $('#variables_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_variables_actions },
            { data: 'type', orderable: true, searchable: true },
            { data: 'key', orderable: true, searchable: true },
            { data: 'value', orderable: true, searchable: true },
            { data: 'description', orderable: true, searchable: true },
        ],
        order: [[3, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_variables"]').click(batch_delete_variables);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_variables_actions(data, type, row){

    const url_info = ($("#variables_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

//create

export function create(){

    let form = $('#new_variable');
    let type = form.find('[name="type"]');
    type.on('change', function(){
        show_hide_media($(this).val());
    });

    show_hide_media(type.val());
}

//show

export function show(params){

    microsite_id = params.microsite_id;
    variable_id = params.variable_id;
    let form = $('#edit_variable');
    let type = form.find('[name="type"]');
    type.on('change', function(){
        show_hide_media($(this).val());
    });

    show_hide_media(type.val());

    form.find('button.delete_media').on('click', function() {
        delete_variable_media($(this).attr('data-media-id'));
    });
}

function show_hide_media(value) {
    switch (value) {
        case 'text':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').removeClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'media':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'html':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'content':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'menu':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'category':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').removeClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;

        case 'tag':
            $('input[name="value"]').closest('.x-form-input').addClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').removeClass('d-none');
            break;
            
        default:
            $('input[name="value"]').closest('.x-form-input').removeClass('d-none');
            $('textarea[name="text"]').closest('.x-form-input').addClass('d-none');
            $('input[name="media"]').closest('.row').addClass('d-none');
            $('input[name="media"]').closest('.row').removeClass('d-flex');
            $('textarea[name="html"]').closest('.x-form-input').addClass('d-none');
            $('select[name="content_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="menu_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="category_id"]').closest('.x-form-input').addClass('d-none');
            $('select[name="tag_id"]').closest('.x-form-input').addClass('d-none');
            break;
    }
}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

function batch_delete_variables(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.variables.batch_delete'].replace('{microsite}', microsite_id);
    
    let variables_id = [];
    $.each(rows_selected, function(index, rowId){
        variables_id.push(rowId);
    });
    
    if(variables_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna variable'));

    } else {

        const title = __('Eliminar variables');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una variable.|[2,*] Estás a punto de eliminar :count variables.', variables_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let variable_id of variables_id){
                        formData.append('variables_id[]', variable_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

function delete_variable_media(media_id) {
    let url = window._routes['microsites.variables.media.delete'].replace('{microsite}', microsite_id).replace('{variable}', variable_id);

    let form_data = new FormData();
    form_data.append('media_id', media_id);
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                let image = $('input[name="media"]');
                let label = image.next('label');
                label.text('');
            }
                            
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

export function filter_taxonomies(data){

    data.results.unshift({
        id: 0,
        name: "Ninguno",
        slug: ""
    });

    return {
        results: $.map(data.results, function(obj, index) {
            return { 
                id: obj.id,
                text: obj.name,
                result: obj.name + '<small class="d-block font-weight-light">' + obj.slug + "</small>"
            };
        })
    };
}